module.exports = __webpack_public_path__ + "img/aboutUs.0753c5e2.png";